var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-container"},_vm._l((_vm.links),function(link){return _c('BtnNav',{key:link.link,attrs:{"name":link.title,"link":'faculties/'+link.code,"small":true}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }